import { ComponentType } from '@angular/cdk/overlay';
import { inject, Injectable } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { KindOfLoader, Loader } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  constructor() {}
  private _snackBar = inject(MatSnackBar);
  private _dialog = inject(MatDialog);
  private loader = new Subject<Loader>();

  // Common Loader configuration
  loader$ = this.loader.asObservable();
  showLoader = (kind: KindOfLoader) =>
    this.loader.next({ isLoading: true, kind });
  hideLoader = (kind: KindOfLoader) =>
    this.loader.next({ isLoading: false, kind });

  openSnackBar = (msg: string, isSuccess: boolean): void => {
    this._snackBar.open(msg, 'OK', {
      duration: 3000,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      panelClass: isSuccess
        ? ['bg-green-100', 'text-green-500', 'z-[100000]']
        : ['bg-red-100', 'text-red-500', 'z-[100000]'],
    });
  };

  openDialogBox = (
    component: ComponentType<any>,
    config: MatDialogConfig
  ): MatDialogRef<any, any> => {
    return this._dialog.open(component, config);
  };
}
